/**
 * Product Form Components
 *
 */
var productJson = {};
var inventoryJson = [];

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.addBtn = this.form.querySelector('[name="add"]');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartElement = document.querySelector('ajax-cart');
    productJson = JSON.parse(this.form.querySelector('[data-productJSON]').innerText);
    for (var item of this.form.querySelectorAll('[data-inventory-variant-json]')) {
      inventoryJson.push(JSON.parse(item.innerText));
    }

    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));

    this.querySelector('[data-compare_product]').addEventListener('click', this._addCompareProduct.bind(this));

    this._checkAlreadyAdded();
    var elementToObserve = document.querySelector('[data-added]');
    let wishlist = setInterval(() => {
      if (elementToObserve != null) {
        const observer = new MutationObserver(function () {
          if (document.querySelector('[data-added="true"]') != null) {
            document.querySelector('[data-added="true"]').style.color = "#8ec640";
          }
          if (document.querySelector('[data-added="false"]') != null) {
            document.querySelector('[data-added="false"]').style.color = "#343434";
          }
        });
        observer.observe(elementToObserve, { childList: true, subtree: true });
        clearInterval(wishlist);
      }
    }, 1000);

    //Change selected Value for color options
    this.querySelectorAll('[data-option_name]').forEach(ele => {
      let option_name = ele.getAttribute('data-option_name');
      ele.querySelectorAll(`[data-options_value="${option_name}"]`).forEach(element => {
        element.addEventListener('mouseover', (event) => {
          ele.querySelector('[data-selected_option]').innerHTML = element.querySelector('.swatch input').value;
        })
        element.addEventListener('mouseout', (event) => {
          ele.querySelector('[data-selected_option]').innerHTML = ele.querySelector('.swatch input:checked').value
        })
      });
    });
  }

  _addCompareProduct(event) {
    if (event.target.closest('[data-compare_product]') != null && event.target.closest('[data-compare_product]').classList.contains('product-added')) {
      event.target.closest('[data-compare_product]').classList.remove('product-added');
      this.querySelector('[data-compare_btn_text]').innerHTML = "add to compare";
      for (var [index, item] of compare_products.entries()) {
        if (item.product.id == productJson.product.id) {
          compare_products.splice(index, 1);
        }
      }
    } else {
      event.target.closest('[data-compare_product]').classList.add('product-added');
      this.querySelector('[data-compare_btn_text]').innerHTML = "added to compare";
      compare_products.push(productJson)
    }
    localStorage.setItem('compareList', JSON.stringify(compare_products))
    this.querySelector('[data-total_comapre_functionality]').innerHTML = `(${compare_products.length})`;
    if (compare_products.length) {
      document.querySelector('[data-compare_page_btn]').classList.add('show');
      document.querySelector('[data-compare_item_length]').innerHTML = `(${compare_products.length})`;
    } else {
      document.querySelector('[data-compare_page_btn]').classList.remove('show')
    }
  }

  _checkAlreadyAdded() {
    var compare_products = localStorage.getItem('compareList');
    if (compare_products != undefined || compare_products != null) {
      compare_products = JSON.parse(compare_products);
      for (const item of compare_products) {
        if (item.product.id == productJson.product.id) {
          this.querySelector('[data-compare_product]').classList.add('product-added');
          this.querySelector('[data-compare_btn_text]').innerHTML = "added to compare";
        }
      }
      this.querySelector('[data-total_comapre_functionality]').innerHTML = `(${compare_products.length})`;
      if (compare_products.length) {
        document.querySelector('[data-compare_page_btn]').classList.add('show');
        document.querySelector('[data-compare_item_length]').innerHTML = `(${compare_products.length})`;
      } else {
        document.querySelector('[data-compare_page_btn]').classList.remove('show');
      }
    }
  }

  _setAddBtnLoading(state) {
    if (!this.addBtn) return;

    this.addBtn.disabled = state;
    this.addBtn.classList[state ? 'add' : 'remove']('loading');
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const addOnItems = [];
    const qtyInput = this.querySelector('[data-qty-input]');
    const pdpContainer = this.closest('.product-details-wrapper');

    this._setAddBtnLoading(true);

    addItems.push(JSON.parse(serializeForm(this.form)))
    if (pdpContainer) {
      let addOnItemsEle = pdpContainer.querySelectorAll('[data-addon-selection]:checked');
      addOnItemsEle.forEach((addOn) => {
        if (addOn.disabled == false) {
          let addOnParent = addOn.closest('addons-form');
          let addOnJSON = {
            id: addOnParent.querySelector('.variant--id').value,
            quantity: addOnParent.querySelector('.product-quantity').value
          }
          addItems.push(addOnJSON);
        }
      });
    }

    const body = JSON.stringify({
      items: addItems
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (document.querySelector('#PopupModal-quickshop')) {
          document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
        }
        if (document.querySelector('.mw-apo-container') != null) {
          setTimeout(() => {
            window.location.reload();
            localStorage.setItem('open_cart', 'true')
          }, 3000);
        } else {
          this.cartElement.getCartData('open_drawer');
        }
        if (qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (document.querySelector('.mw-apo-container') == null) {
          this._setAddBtnLoading(false);
        }
      });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    // this.querySelectorAll('[data-qty-btn]')

    if (action == 'decrease' && currentQty <= 1) {
      return false;
    } else if (action == 'decrease') {
      finalQty = currentQty - 1;
    } else {
      finalQty = currentQty + 1;
    }

    if (finalQty == 1) {
      this.querySelector('.btn-decrease').classList.add('disabled')
    }
    else {
      this.querySelector('.btn-decrease').classList.remove('disabled')
    }
    let var_id = this.querySelector('.btn-decrease').closest('form').querySelector('[name="id"]').value;
    for (var item of inventoryJson) {
      if (parseInt(item.variant.id) == parseInt(var_id)) {
        if (item.variant_inventory_quantity <= finalQty) {
          this.querySelector('.btn-increase').closest('[data-qty-btn]').classList.add('disabled')
        } else {
          this.querySelector('.btn-increase').closest('[data-qty-btn]').classList.remove('disabled')
        }
      }
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define('product-form', ProductForm);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;

    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;


    if (this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    // if (this.form.querySelector('[data-product_customize]').getAttribute('data-product_customize') == 'true') {
    //   this.addBtn = this.form.querySelector('.mw-apo-add-to-cart-cloned');
    // }else{
    //   this.addBtn = this.form.querySelector('[name="add"]');
    // }
    this.setCurrentVariant();
    if (this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;

    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      // Variant name update
      let options = this.form.querySelectorAll('[data-optionindex]');
      options.forEach(option => {
        let lableID = 'option' + option.dataset.optionindex;
        const selectedValue = option.querySelector('input[type="radio"]:checked');
        const lable = option.querySelector('.selected-option');
        if (!lable || !lableID || !selectedValue) return;
        lable.innerHTML = selectedValue.value;
      });
    } else {
      if (this.formType == 'grid') {
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid);
      } else {
        if (event) {
          if (event == 'load') {
            templateProductJS.prototype.manageVariantSlider(this.currentVariant);
          } else if (event) {
            let currentTarget = event.target;
            let pdpContainer = currentTarget.closest('[data-product-container]');
            let quickShopModal = currentTarget.closest('#PopupModal-quickshop');
            let targetName = currentTarget.getAttribute('name') || '';
            targetName = targetName.toLowerCase();

            if (pdpContainer && (targetName.indexOf('color') > -1 || targetName.indexOf('options[color]') > -1)) {
              if (quickShopModal) {
                quickShop.prototype.manageVariantSlider(this.currentVariant);
              } else {
                templateProductJS.prototype.manageVariantSlider(this.currentVariant);
              }
            }
          }
        }

        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');

      if (document.querySelector('[data-quickShop-link]') != null) {
        document.querySelector('[data-quickShop-link]').setAttribute("href", `${window.location.origin}/products/${productJson.product.handle}?variant=${this.currentVariant.id}`)
      }
      if (this.currentVariant.available) {
        if (document.querySelector('[data-instock_varinat]') != null) {
          document.querySelector('[data-instock_varinat]').classList.remove('d-none');
        }
        if (document.querySelector('[data-outofstock_varinat]') != null) {
          document.querySelector('[data-outofstock_varinat]').classList.add('d-none');
        }
      } else {
        if (document.querySelector('[data-instock_varinat]') != null) {
          document.querySelector('[data-instock_varinat]').classList.add('d-none');
        }
        if (document.querySelector('[data-outofstock_varinat]') != null) {
          document.querySelector('[data-outofstock_varinat]').classList.remove('d-none');
        }
      }
      // var color=null;
      // var size=null;
      // for (var [i,option] of productJson.product.options.entries()) {
      //   if(option.toLowerCase().includes('size')){
      //     size=i;
      //   }
      //   if(option.toLowerCase().includes('color')){
      //     color=i;
      //   }
      // }

      // if (size != null && color != null) {
      //   // var size_value=this.currentVariant.options[size];
      //   var color_value=this.currentVariant.options[color];
      //   document.querySelectorAll('[data-options_value]').forEach(ele => {
      //     ele.classList.remove('disabled');
      //     let option_name=ele.getAttribute('data-options_value');
      //     if (option_name.toLowerCase().includes('size')) {
      //       for (var inve of inventoryJson) {
      //         if (inve.variant.options.includes(color_value) && ele.querySelector(`[data-handle]`).value == inve.variant.options[size] && !inve.variant.available && inve.variant_inventory_quantity == 0 && inve.variant.inventory_management == 'shopify') {

      //           document.querySelector(`[data-options_value="${option_name}"] [title="${inve.variant.options[size]}"]`).closest("[data-options_value]").classList.add('disabled');
      //         }
      //       }
      //     }
      //   });
      // } else if(size != null && color == null) {
      //   document.querySelectorAll('[data-options_value]').forEach(ele => {
      //     ele.classList.remove('disabled');
      //     let option_name=ele.getAttribute('data-options_value');
      //     if (option_name.toLowerCase().includes('size')) {
      //       for (var inve of inventoryJson) {
      //         if (inve.variant.title.toLowerCase() == ele.querySelector(`[title]`).getAttribute('title').toLowerCase() && !inve.variant.available) {
      //           ele.classList.add('disabled');
      //         }
      //       }
      //     }
      //   })
      // }
      const productWrap = this.closest('.product-form');
      Shopify.optionsMap = {};
      this.defaultProductOptionSetup(productWrap);
      this.checkOptionSelection(productWrap);
      let var_id = this.closest('form').querySelector('[name="id"]').value;
      for (var item of inventoryJson) {
        if (parseInt(item.variant.id) == parseInt(var_id)) {
          if (item.variant_inventory_quantity <= parseInt(this.closest('form').querySelector('[data-qty-input]').value)) {
            this.closest('form').querySelector('[data-qty-input]').value = item.variant_inventory_quantity;
            if (item.variant_inventory_quantity == 1) {
              this.closest('form').querySelector('.btn-decrease').closest('[data-qty-btn]').classList.add('disabled')
            } else {
              this.closest('form').querySelector('.btn-decrease').closest('[data-qty-btn]').classList.remove('disabled')
            }
            this.closest('form').querySelector('.btn-increase').closest('[data-qty-btn]').classList.add('disabled')
          } else {
            this.closest('form').querySelector('.btn-increase').closest('[data-qty-btn]').classList.remove('disabled')
          }
        }
      }
    }
  }
  // setup product option global data.
  defaultProductOptionSetup(productData) {
    Shopify.arrayIncludes = function (e, t) {
      for (var n = 0; n < e.length; n++)
        if (e[n] == t)
          return !0;
      return !1
    };

    Shopify.uniq = function (e) {
      for (var t = [], n = 0; n < e.length; n++)
        Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
      return t
    };

    var productVariants = JSON.parse(productData.closest('product-form').querySelector('[data-product-variants-json]').innerText).variant;
    var productOptions = productJson.product.options;


    for (var i = 0; i < productVariants.length; i++) {
      var variant = productVariants[i];

      if (variant.available) {
        // Gathering values for the 1st drop-down.
        if (productOptions.length === 1) {
          Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
          Shopify.optionsMap['root'].push(variant.option1);
          Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
        }

        // Gathering values for the 2nd drop-down.
        if (productOptions.length > 1) {
          var key = variant.option1;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option2);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }

        // Gathering values for the 3rd drop-down.
        if (productOptions.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option3);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
      }
    }
  }

  // add disable class to input label
  addDisableClassToOptionLable(productData) {
    var optionData = productData.querySelectorAll('[data-format] .js.product-form__input');
    if (optionData.length > 0) {
      optionData.forEach((el, i) => {
        var optionElement = el.querySelectorAll('.list-unstyled li');
        if (optionElement.length > 0) {
          optionElement.forEach((item, i) => {
            item.querySelector('label').classList.add('is--disable');
          })
        }
      })
    }
  }

  checkOptionSelection(productData) {
    this.addDisableClassToOptionLable(productData);
    var optionsCount = productData.querySelectorAll('[data-format] .js.product-form__input').length;
    if (optionsCount > 0) {
      if (optionsCount === 1) {
        Shopify.optionsMap["root"].forEach((el, i) => {
          productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
        })
      } else if (optionsCount === 2) {
        var option_1 = productData.querySelector('[data-format] .js.product-form__input:first-child .list-unstyled input:checked').value;
        var option_2 = productData.querySelector('[data-format] .js.product-form__input:last-child .list-unstyled input:checked').value;

        if (Shopify.optionsMap[option_1] != undefined) {
          Shopify.optionsMap[option_1].forEach((el, i) => {
            productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
          })
        }

        for (var key in Shopify.optionsMap) {
          if (Shopify.optionsMap[key].indexOf(option_2) != -1) {
            productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${key}"]`).classList.remove('is--disable');
          }
        }
      } else if (optionsCount === 3) {
        var option_1 = productData.querySelector('[data-format] .js.product-form__input:first-child .list-unstyled input:checked').value;
        var option_2 = productData.querySelector('[data-format] .js.product-form__input:nth-child(2) .list-unstyled input:checked').value;
        var option_3 = productData.querySelector('[data-format] .js.product-form__input:last-child .list-unstyled input:checked').value;

        if (Shopify.optionsMap[option_1] != undefined) {
          Shopify.optionsMap[option_1].forEach((el, i) => {
            var option2 = Shopify.optionsMap[option_1][i];
            productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${option2}"]`).classList.remove('is--disable');
          })
        }

        var option2Data = `${option_1} / ${option_2}`;
        Shopify.optionsMap[option2Data].forEach((el, i) => {
          var option3 = Shopify.optionsMap[option2Data][i];
          productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${option3}"]`).classList.remove('is--disable');
        })

        var customOption1 = [];
        var firstSwatchOptions = productData.querySelectorAll('[data-format] .js.product-form__input:first-child .list-unstyled li');
        if (firstSwatchOptions.length > 0) {
          firstSwatchOptions.forEach((optionEl, i) => {
            customOption1.push(optionEl.querySelector('label').getAttribute('title'));
          })
        }
        customOption1.forEach((el, i) => {
          var customOptionName = `${el} / ${option_2}`;
          if (Shopify.optionsMap[customOptionName] != undefined && Shopify.optionsMap[customOptionName].indexOf(option_3) != -1) {
            productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
          } else {
            productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.add('is--disable');
          }
        })

        var customOption2 = [];
        var firstSwatchOptions = productData.querySelectorAll('[data-format] .js.product-form__input:nth-child(2) .list-unstyled li');
        if (firstSwatchOptions.length > 0) {
          firstSwatchOptions.forEach((optionEl, i) => {
            customOption2.push(optionEl.querySelector('label').getAttribute('title'));
          })
        }
        customOption2.forEach((el, i) => {
          var customOption2Name = `${option_1} / ${el}`;
          if (Shopify.optionsMap[customOption2Name] != undefined && Shopify.optionsMap[customOption2Name].indexOf(option_3) != -1) {
            productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
          } else {
            productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.add('is--disable');
          }
        })
      }
    }
  }

  _updateLinks(productGrid) {
    if (!this.currentVariant || !productGrid) return;
    const variantURL = '?variant=' + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector) => {
      options.push(selector.value);
    });
    return options;
  }

  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    const options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
    return options;
  }

  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if (!mappedValues.includes(false)) {
        this.currentVariant = variant;
        if (document.querySelector('[data-available_variant_qty]') != null) {
          let size_index = document.querySelector('[data-available_variant_qty]').getAttribute('data-available_variant_qty');
          for (var item of inventoryJson) {
            if (item.variant.id == this.currentVariant.id) {
              if (item.variant_inventory_quantity > 0 && item.variant_inventory_quantity <= window.globalVariables.limitOfInventory) {
                document.querySelector('[data-in-stock]').classList.add('hide');
                document.querySelector('[data-in-stock]').classList.add('d-none');
                document.querySelector('[data-not-stock]').classList.remove('hide');
                document.querySelector('[data-not-stock]').classList.remove('d-none');
              } else {
                document.querySelector('[data-not-stock]').classList.add('hide');
                document.querySelector('[data-not-stock]').classList.add('d-none');
                document.querySelector('[data-in-stock]').classList.remove('hide');
                document.querySelector('[data-in-stock]').classList.remove('d-none');
              }
              document.querySelectorAll('[data-available_variant_qty] [data-available_unit]').forEach(function (target) {
                target.innerHTML = item.variant_inventory_quantity;
              });
              document.querySelectorAll('[data-available_variant_qty] [data-selected_variant]').forEach(function (target) {
                target.innerHTML = item.variant.options[JSON.parse(size_index) - 1];
              });
            }
          }
        }
        return;
      }
    });
  }

  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if (this.formType == 'product-page') window.history.replaceState({}, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  renderProductInfo(currentVariant, container) {
    if (!currentVariant || !container) return;
    // Price Update
    let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
    let compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if (priceElement) priceElement.innerHTML = price;

    if (comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if (currentVariant.compare_at_price <= 0 || currentVariant.compare_at_price <= currentVariant.price) {
        comparePriceElement.style.display = 'none';
        document.querySelector('[data-saving_parent]').classList.add('discount-added');
        document.querySelector('[data-currentprice]').classList.remove('text-danger');
      } else {
        comparePriceElement.style.display = 'inline-block';
        var product_discount = currentVariant.compare_at_price - currentVariant.price;
        product_discount = Shopify.formatMoney(product_discount, window.globalVariables.money_format);
        document.querySelector('[data-saving_price]').innerHTML = product_discount;
        document.querySelector('[data-saving_parent]').classList.remove('discount-added');
        document.querySelector('[data-currentprice]').classList.add('text-danger');
      }
    }
    if (currentVariant.sku != '' && currentVariant.sku != null) {
      document.querySelector('[data-sku_parent]').innerHTML = `SKU #: ${currentVariant.sku}`;
      document.querySelector('[data-sku_parent]').classList.remove('hide');
    } else {
      document.querySelector('[data-sku_parent]').classList.add('hide');
    }
    // Variant name update
    let options = this.form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let lableID = 'option' + option.dataset.optionindex;
      const lable = option.querySelector('.selected-option');
      if (!lable || !lableID) return;
      lable.innerHTML = currentVariant[lableID];
    });

    // Grid Image Update on variant selection
    if (this.formType == 'grid') {
      if (!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src;
      if (updatedSrc) {
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    } else {

      if (!currentVariant.featured_image) return;

      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(`.product--media[data-mediaID="${imageID}"]`);
      let image_media = JSON.parse(document.querySelector('[data-productMedia]').textContent);

      var thumbnails = document.querySelectorAll('.product-thumbnails [data-mediaID]')


      if (this.formType == 'quickshop') {
        imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${imageID}"]`);
      }

      thumbnails.forEach((ele, i) => {
        let img_alt = ele.querySelector('img').getAttribute('alt');
        if (currentVariant.options.toString().toLowerCase().includes(img_alt)) {
          productSlider.slideTo(i, 2000, true)
        }
      });

      if (!imageSlide) return;

      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);

      if (quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if (productSlider) productSlider.slideTo(slideIndex, 2000, true);

    }

  }

  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if (this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;

      this.addBtn.classList.remove('btn-primary');
      this.addBtn.classList.add('btn-secondary')

    } else if (this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);

      if (this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;

      this.addBtn.classList.remove('btn-primary');
      this.addBtn.classList.add('btn-secondary');
    } else {
      this.addBtn.removeAttribute('disabled');
      if (this.form.classList.contains('cart-upsell-form')) {
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
      } else {
        for (const item of inventoryJson) {
          if (item.variant.id == this.currentVariant.id) {
            if (this.currentVariant.available && item.variant_inventory_quantity <= 0 && this.currentVariant.inventory_management != null) {
              this.addBtn.classList.remove('btn-primary')
              this.addBtn.classList.add('btn-secondary')
              this.addBtn.querySelector('.add-text').textContent = window.variantStrings.preorder;
              document.querySelector('[data-preorder_text]').classList.remove('hide');
            } else {
              this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
              document.querySelector('[data-preorder_text]').classList.add('hide');
              this.addBtn.classList.add('btn-primary');
              this.addBtn.classList.remove('btn-secondary');
            }
          }
        }
      }
    };
  }

  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if (colorSwatchContainer) {
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      });
    }
  }
}
customElements.define('variant-radios', VariantRadios);
